module.exports = __webpack_public_path__ + "static/media/mainimg-01.f63fb79b.png";